import React from "react";
import spinner from "../../asset/Spinner.svg";
import "../styles/spinner.css";

const Spinner = () => {
  return (
    <div className="spinner__component">
      <img src={spinner} alt="" />
    </div>
  );
};

export default Spinner;
